var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Expose } from 'class-transformer';
import { IsBoolean, IsEnum, IsString, IsUUID } from 'class-validator';
import { Heilmittelbereich } from '../../pvs-billing/enums/heilmittelbereich.enum.js';
/**
 * A Leistungserbringer as returned to the client: the practice's billing
 * identity for one Heilmittelbereich at one OfficeLocation.
 *
 * There is no `validFrom` / `validTo` and there will not be one. §125-Vertrag
 * §17 Abs. 3 forbids stilllegen an IK before every Forderung under it is billed,
 * so an IK is never retired out from under open work. Time enters when the
 * Abrechnungslauf snapshots IK + Abrechnungscode onto what it emits.
 */
export class LeistungserbringerResponseDto {
    id;
    createdAt;
    updatedAt;
    officeLocationId;
    heilmittelbereich;
    /** Nine digits, no separators. GR-IK Nr. 3.3 formatting. */
    ik;
    /** Two characters — the LEGS Abrechnungscode the practice bills under. */
    billingCode;
    /**
     * Does this Leistungserbringer bill §302 electronically at all (#1513)?
     *
     * Off for everything that existed before the flag did. It is the lever for a
     * per-Heilmittelbereich rollout — Physio electronic, Ergo still on paper —
     * and **not** the Testindikator, which is per `(IK × Kostenträger-IK)` and
     * says what the *Kasse* thinks.
     */
    participatesInGkvBilling;
}
__decorate([
    Expose(),
    IsUUID(),
    __metadata("design:type", String)
], LeistungserbringerResponseDto.prototype, "id", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Date)
], LeistungserbringerResponseDto.prototype, "createdAt", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Date)
], LeistungserbringerResponseDto.prototype, "updatedAt", void 0);
__decorate([
    Expose(),
    IsUUID(),
    __metadata("design:type", String)
], LeistungserbringerResponseDto.prototype, "officeLocationId", void 0);
__decorate([
    Expose(),
    IsEnum(Heilmittelbereich),
    __metadata("design:type", String)
], LeistungserbringerResponseDto.prototype, "heilmittelbereich", void 0);
__decorate([
    Expose(),
    IsString(),
    __metadata("design:type", String)
], LeistungserbringerResponseDto.prototype, "ik", void 0);
__decorate([
    Expose(),
    IsString(),
    __metadata("design:type", String)
], LeistungserbringerResponseDto.prototype, "billingCode", void 0);
__decorate([
    Expose(),
    IsBoolean(),
    __metadata("design:type", Boolean)
], LeistungserbringerResponseDto.prototype, "participatesInGkvBilling", void 0);
//# sourceMappingURL=leistungserbringer.response.dto.js.map